import React from 'react';
import DishCard from '../DishCard';

export default function GridLayout({ 
  filtered, 
  categories, 
  cart, 
  onUpdateQuantity 
}) {
    return (
        <div className="layout-grid">
            {categories.filter(cat => cat !== 'All').map(cat => {
                const catDishes = filtered.filter(d => d.category === cat);
                if (catDishes.length === 0) return null;
                return (
                    <section key={cat} id={`cat-${cat}`} className="mb-8 pt-2">
                        <h2 className="text-base font-black text-charcoal mb-4 flex items-center gap-2">
                            {cat}
                            <span className="w-8 h-0.5 bg-primary rounded-full" />
                        </h2>
                        
                        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
                            {catDishes.map(dish => (
                                <div key={dish.id}>
                                    <DishCard 
                                        dish={dish} 
                                        layout="grid"
                                        quantity={cart[dish.id] || 0} 
                                        onUpdateQuantity={(q, e) => onUpdateQuantity(dish.id, q, e, dish)} 
                                    />
                                </div>
                            ))}
                        </div>
                    </section>
                );
            })}
        </div>
    );
}
